/* eslint-disable react/prop-types */
'use client'
import React, { useMemo } from 'react'
import { BannerAdsProps, GetTargetingProps } from '~types/index'
import BannerAdsCarousel from './BannerAdsCarousel'
import BannerAdsSection from './BannerAdsSection'
import BannerAdsSlide from './BannerAdsSlide'
import SkeletonAds from './Skeleton'

const getTargeting = ({
  extraTargeting,
  pagetype,
  searchterm,
  store,
}: GetTargetingProps) => ({
  env: 'staging',
  ...extraTargeting,
  ...(pagetype && { pgtype: pagetype }),
  ...(searchterm && { search: searchterm }),
  storeReference: store?.code,
})

const BannerAds = ({
  id,
  path,
  size = ['fluid'],
  aspectRatio = '',
  adsPerRow = 0,
  pagetype,
  searchterm,
  extraTargeting,
  carrouselLength = 0,
  autoplaySpeed = 8000,
  showLoad = true,
  freezingTimeToLoad = 0,
  shapeSquare,
  store,
}: BannerAdsProps) => {
  const targeting = useMemo(
    () =>
      getTargeting({
        extraTargeting,
        pagetype,
        searchterm,
        store,
      }),
    [extraTargeting, pagetype, searchterm, store]
  )

  const skeleton = useMemo(
    () => (showLoad ? <SkeletonAds aspectRatio={aspectRatio} /> : null),
    [showLoad, aspectRatio]
  )

  if (
    adsPerRow > 0 &&
    typeof window !== 'undefined' &&
    window?.location?.pathname === '/search'
  ) {
    return (
      <BannerAdsSection
        id={id}
        path={path}
        size={size}
        skeleton={skeleton}
        targeting={targeting}
        aspectRatio={aspectRatio}
        adsPerRow={adsPerRow}
      />
    )
  }

  return carrouselLength ? (
    <BannerAdsCarousel
      id={id}
      path={path}
      size={size}
      carrouselLength={carrouselLength}
      autoplaySpeed={autoplaySpeed}
      skeleton={skeleton}
      targeting={targeting}
      aspectRatio={aspectRatio}
      freezingTimeToLoad={freezingTimeToLoad}
    />
  ) : (
    <BannerAdsSlide
      id={id}
      path={path}
      size={size}
      skeleton={skeleton}
      targeting={targeting}
      aspectRatio={aspectRatio}
      shapeSquare={shapeSquare}
      freezingTimeToLoad={freezingTimeToLoad}
    />
  )
}

export default React.memo(BannerAds)
